class PageActions {
	private pageActionsElement?: HTMLElement;
	private bannerElement?: HTMLElement | null;

	setPageActionsLocation() {

		if (!this.pageActionsElement) {
			return;
		}

		if (!this.bannerElement) {
			return;
		}

		const bannerStyles = getComputedStyle(this.bannerElement);

		if (bannerStyles.display === "none") {
			this.pageActionsElement.style.bottom = "35px";
			return;
		}

		const gdprBannerHeight = parseInt(bannerStyles.height);

		this.pageActionsElement.style.bottom = `${gdprBannerHeight + 1}px`;
	}

	init() {
		this.pageActionsElement = document.querySelector(".page-actions") as HTMLElement;
		this.bannerElement = document.querySelector(".gdpr-banner");

		if (!this.bannerElement) {
			return;
		}

		this.setPageActionsLocation();

		window.addEventListener("resize", () => {
			this.setPageActionsLocation();
		});
	}
}

window.addEventListener("load", () => {
	const pageActions = new PageActions();
	pageActions.init();
});
